module.exports = __webpack_public_path__ + "img/handshake.8d97163a.svg";